/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { PluginDescription } from '../models/plugin-description';
@Injectable({
  providedIn: 'root',
})
class TransformService extends __BaseService {
  static readonly TransformGetTransformsPath = '/api/Transform/GetTransforms';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  TransformGetTransformsResponse(): __Observable<__StrictHttpResponse<Array<PluginDescription>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Transform/GetTransforms`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PluginDescription>>;
      })
    );
  }  TransformGetTransforms(): __Observable<Array<PluginDescription>> {
    return this.TransformGetTransformsResponse().pipe(
      __map(_r => _r.body as Array<PluginDescription>)
    );
  }
}

module TransformService {
}

export { TransformService }
